import { createGlobalStyle } from 'styled-components';

export const ImageUploadPopoverStyles = createGlobalStyle`
    .image-upload-popover {
        .ant-popover-arrow::after, .ant-popover-arrow::before {
            background-color: ${({ theme }) => theme.token.colorBgContainer};
        }

        .ant-popover-inner {
            background-color: ${({ theme }) => theme.token.colorBgContainer};

            .popover-content {
                display: flex;
                flex-direction: column;
                gap: 1rem;
                background-color: ${({ theme }) => theme.token.colorBgContainer};

                .popover-title {
                    color: ${({ theme }) => theme.token.colorTextHeading};
                    font-size: ${({ theme }) => theme.token.fontSize}px;
                    font-weight: ${({ theme }) => theme.token.fontWeightStrong};
                    line-height: ${({ theme }) => theme.token.lineHeight};
                }

                .ant-upload {
                    width: 100%;

                    .ant-btn {
                        justify-content: flex-start;
                        color: ${({ theme }) => theme.token.colorPrimary};
                        font-size: ${({ theme }) => theme.token.fontSize}px;
                        font-weight: ${({ theme }) => theme.token.fontWeightNormal};
                        line-height: ${({ theme }) => theme.token.lineHeight};
                    }
                }
            }
        }
    }
`;
